import UserImg from "assets/images/mocks/user-img.png";
import { useAuth } from "contexts/AuthContext";
import { imageOnError } from "utils/imageFallbacks";

export default function ProfileDropdown() {
  const { user } = useAuth();

  const displayName = user
    ? [user.firstname, user.lastname].filter(Boolean).join(" ") || "Admin"
    : "Admin";
  const displayEmail = user?.email ?? "";
  const displayPhoto = user?.photo ?? null;

  return (
    <div className="hidden md:flex items-center gap-4">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.75 9.00526V9.70979C18.75 10.5554 18.99 11.382 19.4419 12.0856L20.5499 13.8099C21.5609 15.385 20.7889 17.5257 19.03 18.023C14.4337 19.3257 9.5663 19.3257 4.97005 18.023C3.21106 17.5257 2.43907 15.385 3.45006 13.8099L4.55805 12.0856C5.01126 11.3762 5.25176 10.5517 5.25105 9.70979V9.00526C5.25105 5.13635 8.27303 2 12 2C15.727 2 18.75 5.13635 18.75 9.00526Z"
          fill="black"
        />
        <circle cx="16" cy="7" r="3" fill="#FF0A0A" />
        <mask id="path-3-inside-1_5408_12486" fill="white">
          <path d="M7 18C7.72778 20.3307 9.69111 22 12 22C14.3089 22 16.2722 20.3307 17 18" />
        </mask>
        <path
          d="M7.95454 17.7019C7.78993 17.1748 7.22911 16.8808 6.70193 17.0455C6.17475 17.2101 5.88084 17.7709 6.04546 18.2981L7 18L7.95454 17.7019ZM17.9545 18.2981C18.1192 17.7709 17.8252 17.2101 17.2981 17.0455C16.7709 16.8808 16.2101 17.1748 16.0455 17.7019L17 18L17.9545 18.2981ZM7 18L6.04546 18.2981C6.87852 20.9659 9.17489 23 12 23V22V21C10.2073 21 8.57703 19.6954 7.95454 17.7019L7 18ZM12 22V23C14.8251 23 17.1215 20.9659 17.9545 18.2981L17 18L16.0455 17.7019C15.423 19.6954 13.7927 21 12 21V22Z"
          fill="black"
          mask="url(#path-3-inside-1_5408_12486)"
        />
      </svg>

      <div>
        <p className="text-14 font-aileron_sb text-brand_secondary">
          {displayName}
        </p>
        <p className="text-14 font-aileron_r text-[#6D6D6D] leading-3">
          {displayEmail}
        </p>
      </div>

      <img
        src={displayPhoto || UserImg}
        onError={imageOnError(UserImg)}
        alt="user"
        className="w-10 h-10 rounded-full border border-neutral_stroke_1 object-cover"
      />
    </div>
  );
}
